export default "__VITE_ASSET__CqY7_O6b__"